import React from 'react';
import {Box, Divider} from '@material-ui/core';
import {DetailWrapper, DetailItemRow, DetailItemTitle} from '../../../Shared/styles';
import DetailTitleRow from '../DetailTitleRow/DetailTitleRow';
import {Values} from "Tools/Values";

interface IUserRoles {
    userRoles: {
        id: string,
        name: string,
    }[],
}

const UserRoles = ({userRoles}: IUserRoles) => (
    <DetailWrapper>
        <DetailTitleRow title={Values.getLocalizationValue('supportedUserRoles')} />

        {userRoles?.map((role) => (
            <Box key={role.id}>
                <DetailItemRow>
                    <DetailItemTitle>{role.name}</DetailItemTitle>
                </DetailItemRow>
                
                <Divider/>
            </Box>
        ))}
    </DetailWrapper>
);

export default UserRoles;
